// extracted by mini-css-extract-plugin
module.exports = {"megami_container":"MegamiSlotCylinder_megami_container_3XQMN","megami":"MegamiSlotCylinder_megami_2CH2y"};